
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiChartDisplaySettingsProposal as ObiChartDisplaySettingsProposalElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-chart-display-settings-proposal.js';
 
 
 

 
 export const ObiChartDisplaySettingsProposal = createComponent({
   react: React,
   tagName: 'obi-chart-display-settings-proposal',
   elementClass: ObiChartDisplaySettingsProposalElement,
   events: {
     
   }
  });
 
 